if(window.productCustomPrices){
  window.customVariantChangeHandler = (evt, passedVariant)=>{
    let variant;
    if(evt)
      variant = evt.detail.variant;
    else
      variant = passedVariant;
    if(!variant)
      return;
    if(!window.productCustomPrices)
      return;
    const correctPrice = window.productCustomPrices.find(item=>item.id == variant.id)
    if(!correctPrice)
      return;
    document.querySelector('.customPriceContainer').innerText = `$${correctPrice.price.toFixed(2)}`
  }
  //Running the function on initial page load (Don't have access to metafields, so this needs to be done using JS. Can replace with Liquid using metafields if necessary so it comes statically from server)
  const productForm = document.querySelector('.product-single__form')
  const currentVariant = {
    id: productForm.querySelector('[name="id"]').value
  }
  window.customVariantChangeHandler(undefined, currentVariant)
}